export default "__VITE_ASSET__Dn7W2Z88__"